import Zipcode from '../../models/Zipcode'

import zipcodeApi from '../api/zipcode.api'

class ZipcodeService {
  async searchBy(zipCode: string): Promise<Zipcode> {
    try {
      return await zipcodeApi.get(zipCode)
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}

export default new ZipcodeService()
